import AppWebnShop from '@/pages/AppWebnShop/Template'
import Points from '@/pages/AppWebnShop/Points'
import Order from '@/pages/AppWebnShop/Order'
import Account from '@/pages/AppWebnShop/Account'
export default {
    path: '/AppWebnShop',
    component: AppWebnShop,
    children: [
        {
            path: '',
            name: 'AppWebnShopPoints',
            component: Points,
        },
        {
            path: ':id/:id1',
            name: 'AppWebnShopOrder',
            component: Order,
        },
        {
            path: 'account',
            name: 'AppWebnShopAccount',
            component: Account,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/appwebnshop.js